package info.rezident.app.ui.theme

import androidx.compose.runtime.Immutable
import androidx.compose.runtime.compositionLocalOf
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.rgba
import com.varabyte.kobweb.silk.theme.colors.ColorPalette
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.Color

val LocalAppColors = compositionLocalOf {
    lightPalette
}

// Utility colors
private val white = Color("#F3F3F0")
private val white70 = rgba(243, 243, 240, 180)
private val lightGrey = Color("#DCDCDC")
private val regularGrey = Color("#808080")
private val mediumGrey = Color("#505050")
private val darkGrey = Color("#1C1C1E")
private val black = Color("#121212")
private val black70 = rgba(18, 18, 18, 180)

// Brand colors
private val skyBlue = Color("#8ECAE6")
private val skyBlue70 = rgba(142, 202, 230, 178)
private val skyBlue60 = rgba(142, 202, 230, 153)
private val blueGreen = Color("#219EBC")
private val prussianBlue = Color("#023047")
private val prussianBlue80 = rgba(2, 48, 71, 204)
private val selectiveYellow = Color("#FFB703")
private val utOrange = Color("#FB8500")

@Immutable
data class AppColors(
    val background: CSSColorValue,
    val header: CSSColorValue,
    val hero: CSSColorValue,
    val section: CSSColorValue,
    val surface: CSSColorValue,
    val accent: CSSColorValue,
    val accentColorPalette: ColorPalette,
    val onAccent: CSSColorValue,
    val text: CSSColorValue,
    val textSecondary: CSSColorValue,
    val textTertiary: CSSColorValue,
    val icon: CSSColorValue,
    val loading: CSSColorValue,
    val error: CSSColorValue
)

val lightPalette = AppColors(
    background = white,
    header = white70,
    hero = skyBlue70,
    section = skyBlue60,
    surface = white,
    accent = selectiveYellow,
    accentColorPalette = accentColorPalette,
    onAccent = prussianBlue,
    text = prussianBlue,
    textSecondary = black,
    textTertiary = mediumGrey,
    icon = utOrange,
    loading = skyBlue,
    error = Color("#FF3B30")
)

val darkPalette = AppColors(
    background = black,
    header = black70,
    hero = prussianBlue80,
    section = prussianBlue80,
    surface = darkGrey,
    accent = selectiveYellow,
    accentColorPalette = accentColorPalette,
    onAccent = prussianBlue,
    text = skyBlue,
    textSecondary = lightGrey,
    textTertiary = regularGrey,
    icon = utOrange,
    loading = skyBlue,
    error = Color("#FF453A")
)